import ViewVSContainer from "./ViewVSContainer";

export default ViewVSContainer;
